import { ActivityAgendaParticipations } from "apps/console/modules/program/workflow/associateProgram/agenda/details";
import { useParams } from "react-router-dom";
import useLogAnalyticsScreenHook from "apps/myExperience/context/analyticsWrapper/hooks/useLogAnalyticsScreenHook";
import { AnalyticsContextEntityTypeEnum, AnalyticsScreenNameEnum } from "shared/enums/AnalyticsEnums";

export function ActivityAgendaParticipationsForMyExperience() {
  const { activityAgendaId = "", programParticipantId = "" } = useParams();
  useLogAnalyticsScreenHook({
    properties: {
      screenType: AnalyticsScreenNameEnum.MANAGE_ACTIVITY_PARTICIPANTS,
      contextEntityType: AnalyticsContextEntityTypeEnum.ACTIVITY,
      contextEntityId: activityAgendaId,
      programParticipantId
    }
  });
  return <ActivityAgendaParticipations canManageParticipants={true} />;
}
